module.exports = "pegasus/assets/themelp1/tickets/101.png";